var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarShoots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30004 13.0312V19.8013M9.30004 13.0312L3.20703 19.8013M9.30004 13.0312L15.393 19.8013",
    stroke: "#EFEFEF",
    strokeWidth: 1.354,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3994 2.19922H3.21338C2.46558 2.19922 1.85938 2.80543 1.85938 3.55322V11.6772C1.85938 12.425 2.46558 13.0312 3.21338 13.0312H15.3994C16.1472 13.0312 16.7534 12.425 16.7534 11.6772V3.55322C16.7534 2.80543 16.1472 2.19922 15.3994 2.19922Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.354,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30444 9.64794C10.4261 9.64794 11.3354 8.73863 11.3354 7.61694C11.3354 6.49525 10.4261 5.58594 9.30444 5.58594C8.18275 5.58594 7.27344 6.49525 7.27344 7.61694C7.27344 8.73863 8.18275 9.64794 9.30444 9.64794Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.354,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarShoots);
export default __webpack_public_path__ + "static/media/sidebar-shoots.a66cdadbb14652c0c1b1a228133d6a3a.svg";
export { ForwardRef as ReactComponent };